<template>
  <div>
    <!-- <div class="row mt-3">
      <div class="col-md-6 col-sm-12 text-left">
        <label for="question" class="mb-1 input-label bold-text"
          >Ask a Question</label
        >
        <a-input
          :maxLength="maxQuestion"
          :size="'large'"
          placeholder="Please be Specific and Concise"
          style="background-color: white"
          v-model.lazy="$v.formResponses.question.$model"
        />
        <div class="error-container" v-if="$v.formResponses.question.$error">
          <div class="error-item" v-if="!$v.formResponses.question.required">
            Required
          </div>
        </div>
        <p class="text-right">
          <small class="font-light"
            >Characters remaining:
            {{ maxQuestion - formResponses.question.length }}
          </small>
        </p>
      </div>
      <div class="col-md-6 col-sm-12 text-left">
        <label for="category" class="mb-2 input-label bold-text"
          >Select Category</label
        >
        <a-select
          :size="'large'"
          class="w-100"
          style="width: 120px"
          v-model="$v.formResponses.category.$model"
        >
          <a-select-option
            :value="category.key_name"
            v-for="category in categories"
            :key="category.id"
            >{{ category.display_name }}</a-select-option
          >
        </a-select>
        <div class="error-container" v-if="$v.formResponses.category.$error">
          <div class="error-item" v-if="!$v.formResponses.category.required">
            Choose a category
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 position-relative">
      <div class="col-md-12 col-sm-12 text-left">
        <label for="description" class="mb-1 input-label bold-text"
          >Additional Details</label
        >
        <div class="message-input-container">
          <a-textarea
            :value="formResponses.description"
            :maxLength="maxDescription"
            :size="'large'"
            placeholder="Describe your question"
            v-model.lazy="$v.formResponses.description.$model"
          />
          <div class="flexing">
            <div :class="fileList.length ? 'd-none' : ''" />

         

            <a-upload
              v-if="fileList.length > 0"
              listType="picture-card"
              :fileList="fileList"
              @preview="handlePreview"
              @change="handleChange"
            >
             
            </a-upload>

            

            <div :style="{ left: '-42px' }" class="position-relative cp">
              <font-awesome-icon
                size="2x"
                class="camera-icon-inp"
                :style="{ color: getPrimaryColor(), opacity: 1 }"
                :icon="['fas', 'camera']"
              />
              <input
                class="camera-icon-inp"
                type="file"
                ref="fileInput"
                @change="handlePicUpload()"
              />
            </div>
          </div>
        </div>
        <div class="error-container" v-if="$v.formResponses.description.$error">
          <div class="error-item" v-if="!$v.formResponses.description.required">
            Required
          </div>
        </div>
        <p class="text-right">
          <small class="font-light"
            >Characters remaining:
            {{ maxDescription - formResponses.description.length }}</small
          >
        </p>

       
      </div>
    </div>
    <div class="row mt-3">
      <div class="buttons-group text-center col-12 mb-5 m-ask-btn">
        <a-button
          :loading="loading"
          class="dovemed-button font-white ml-4 primary-button"
          @click="postQuestion()"
          :style="{ background: getPrimaryColor() }"
          >Ask</a-button
        >
      </div>
    </div> -->
    <div class="d-flex justify-content-center">
      <!-- <button
        @click="() => $refs.treatmentQuestionModal.show()"
        :style="{
          background: getPrimaryColor(),
          color: 'white !important',
          border: '1px solid ' + getPrimaryColor()
        }"
        class="dovemed-button primary-button ml-4"
      >
        ASK A QUESTION
      </button> -->
      <h4>
        Click
        <span
          :style="{
            'font-weight': 'bold',
            cursor: 'pointer',
            'text-decoration': 'underline'
          }"
          @click="() => $refs.treatmentQuestionModal.show()"
          >here</span
        >
        to ask a question.
      </h4>
    </div>
    <TreatmentQuestionModal ref="treatmentQuestionModal" /> 
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import s3Upload from "../../../utilities/imageUploader";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import TreatmentQuestionModal from "../../Modals/TreatmentQuestionModal.vue";

const QARepository = RepositoryFactory.get("qa");
const UserRepository = RepositoryFactory.get("user");
const AppRepository = RepositoryFactory.get("app");

export default {
  name: "AskQuestion",
  components: {
    TreatmentQuestionModal
  },
  data() {
    return {
      uiState: "submit_not_clicked",
      fileList: [],
      previewImage: null,
      previewVisible: false,
      empty: true,
      treatment: null,
      errors: false,
      formResponses: {
        question: "",
        description: "",
        category: "",
        question_attach: []
      },
      categories: null,

      maxQuestion: 140,
      maxDescription: 3000,
      loading: false
    };
  },
  validations: {
    formResponses: {
      question: {
        required
      },
      description: {
        required
      },
      category: {
        required
      }
    }
  },

  created() {
    this.init();

    AppRepository.getTreatment(this.$route.params.id)
      .then(res => {
        if (res.status === 204) {
          AppRepository.getOtherTreatment(this.$route.params.id)
            .then(res => {
              console.log(res, "res");
              this.treatment = res.data.data.data[0];

              this.formResponses.category = "Treatment";
              this.formResponses.description =
                this.formResponses.description +
                res.data.data.data[0].display_name;
            })
            .catch(err => null);
        }
        this.treatment = res.data.data.data[0];
        this.formResponses.category = "Treatment";
        this.formResponses.description =
          this.formResponses.description + res.data.data.data[0].display_name;
      })
      .catch(err => null);
  },

  methods: {
    init() {
      QARepository.getQuestionCategories()
        .then(res => {
          this.categories = res.data.data;
        })
        .catch(err => null);
    },

    /**
     * Handle Question category
     */
    handleCategory(value) {
      this.formResponses.category = value;
      this.$v.formResponses.category.$touch();
    },
    /**
     * Get the location of the user using Geolocation
     */
    getLocation() {
      return new Promise(function(resolve, reject) {
        navigator.geolocation.getCurrentPosition(
          function(pos) {
            const latitude = pos.coords.latitude;
            const longitude = pos.coords.longitude;
            resolve({ latitude, longitude });
          },
          function(error) {
            reject("unable to fetch location");
          }
        );
        reject("unable to fetch location");
      });
    },

    /**
     * Handle image Upload
     */
    async handleChange(data) {
      this.fileList.length === 1
        ? (this.fileList = [])
        : this.fileList.splice(data.file.uid - 1, 1);
      this.formResponses.question_attach.splice(data.file.uid - 1, 1);
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    async handlePicUpload() {
      this.loading = true;
      const file = this.$refs.fileInput.files[0];
      try {
        const urlPayload = { file_name: [file.name] };
        const urlData = await UserRepository.getPresignedUrl(urlPayload);
        const fileName = urlData.data.data.filename[0];
        await s3Upload(urlData.data.data.url[0], file);
        this.formResponses.question_attach.push(fileName);
        this.loading = false;
        const fileListData = {
          uid: this.formResponses.question_attach.length,
          name: file.name,
          status: "done",
          url: urlData.data.data.preview_url
        };
        this.fileList.push(fileListData);
      } catch (err) {
        this.loading = false;
      }
    },

    /**
     * Post a Question
     */
    async postQuestion() {
      this.loading = true;
      this.$v.$touch();
      let loc;
      try {
        loc = await this.getLocation();
      } catch (error) {
        loc = {
          lat: null,
          lon: null
        };
      }
      const payload = {
        user_circle: this.currentCircle.id,
        category: this.formResponses.category,
        question: this.formResponses.question,
        question_description: this.formResponses.description,
        question_attach:
          this.formResponses.question_attach.length > 0
            ? this.formResponses.question_attach
            : null,
        question_location: "location",
        latlong: {
          latitude: loc.lat,
          longitude: loc.lon
        },
        user: this.authUser.user.id
      };

      this.empty = !this.$v.formResponses.$anyDirty;
      this.errors = this.$v.formResponses.$anyError;
      this.uiState = "submit_clicked";
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`
      };

      if (this.errors === false && this.empty === false) {
        this.$http
          .post(`${process.env.BASE_API_URL}/askquestions/`, payload, {
            headers
          })
          .then(res => {
            this.formResponses.question = "";
            this.formResponses.description = "";
            this.formResponses.category = "";
            this.formResponses.question_attach = [];
            this.$v.$reset();
            this.loading = false;
            this.$notification.success({
              message: "Success",
              description: "Your question has been posted."
            });
            this.$router.push({ name: "QASearch" });
          })
          .catch(err => {
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
          });
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.camera-icon-inp {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
}
.file-icon {
  position: absolute;
  bottom: 50px;
  right: 30px;
}

.message-input-container {
  display: block;
  border: 1px solid #e2e2e2;
  background: #f7f7f7;
  border-radius: 10px;
  padding: 10px 20px;

  .fa-camera {
    width: 35px;
    height: 35px;
    position: relative;
    vertical-align: text-top;
    cursor: pointer;
  }
  .camera-icon-inp {
    opacity: 0;
    position: absolute;
    right: -40px;
    top: -40px;
    width: 40px;
    // height: 40px;
    cursor: pointer;
    z-index: 5;
  }

  textarea {
    border: transparent;
    border-radius: 0;
    border-bottom: 1px solid #e2e2e2;

    &:focus {
      box-shadow: 0 0 transparent;
    }
  }

  .button-container {
    padding: 5px 0 0 0;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    input {
      height: 25px;
    }
  }
}
.flexing {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/home/QA/AskQuestion.vue